import React, { useState, useEffect } from "react";
import axios from "axios";
import Input from "../../CoreComponent/Input";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import httpService from "../../common/httpService";
import "./style.scss";
import Select from "../../CoreComponent/Select";
import { Typography, Button, IconButton } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

const RoomPriceForm = () => {
  const [allConference, setAllConference] = useState([]);
  const [conferenceId, setConferenceId] = useState("");
  const [hotels, setHotels] = useState([{
    hotelName: "",
    starRating: "",
    singleBasePrice: "",
    doubleBasePrice: "",
    tripleBasePrice: ""
  }]);

  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const starRatingOptions = [
    { label: "Five Star ⭐⭐⭐⭐⭐", value: "five_star" },
    { label: "Four Star ⭐⭐⭐⭐", value: "four_star" },
    { label: "Three Star ⭐⭐⭐", value: "three_star" }
  ];

  // ✅ STAR RATING HELPER FUNCTION - Ye fix karega display issue
  const getStarRatingValue = (starRating) => {
    if (!starRating) return null;
    const option = starRatingOptions.find(opt => opt.value === starRating);
    return option ? { label: option.label, value: option.value } : null;
  };

  const handleRegister2 = async (e) => {
    e.preventDefault();

    try {
      // Validate all hotels have required fields
      const isValid = hotels.every(hotel => 
        hotel.hotelName && 
        hotel.starRating && 
        hotel.singleBasePrice && 
        hotel.doubleBasePrice && 
        hotel.tripleBasePrice
      );

      if (!isValid || !conferenceId?.value) {
        toast.error("Please fill all required fields for all hotels");
        return;
      }

      // Send all hotels data
      const response = await httpService({
        method: "POST",
        url: `${BaseUrl}/room-prices`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          conference_id: conferenceId?.value,
          hotels: hotels.map(hotel => ({
            hotel_name: hotel.hotelName,
            star_rating: hotel.starRating,
            single_base_price: hotel.singleBasePrice,
            double_base_price: hotel.doubleBasePrice,
            triple_base_price: hotel.tripleBasePrice,
          }))
        },
        onSuccess: (data) => {
          toast.success(data.success || "Room prices added successfully!");
          // Reset form
          setHotels([{ hotelName: "", starRating: "", singleBasePrice: "", doubleBasePrice: "", tripleBasePrice: "" }]);
        },
      });
    } catch (error) {
      toast.error(error?.response?.data?.error || "An error occurred while adding room prices.");
    }
  };

  const getConference = () => {
    const url = `${BaseUrl}/conferences/all`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAllConference(
          response.data.data?.map((item) => ({
            label: item?.title,
            value: item?.id,
          }))
        );
      })
      .catch((error) => {
        toast.error("Error fetching conferences");
      });
  };

  const addHotel = () => {
    setHotels([...hotels, { hotelName: "", starRating: "", singleBasePrice: "", doubleBasePrice: "", tripleBasePrice: "" }]);
  };

  const removeHotel = (index) => {
    if (hotels.length > 1) {
      const updatedHotels = hotels.filter((_, i) => i !== index);
      setHotels(updatedHotels);
    }
  };

  const updateHotelField = (index, field, value) => {
    const updatedHotels = hotels.map((hotel, i) =>
      i === index ? { ...hotel, [field]: value } : hotel
    );
    setHotels(updatedHotels);
  };

  useEffect(() => {
    getConference();
  }, []);

  return (
    <div className="prices-form-room">
      <div className="room-prices-form">
        <form onSubmit={handleRegister2} className="form-container">
          <Typography 
            variant="h6"
            sx={{
              color: '#c62828',
              backgroundColor: '#f1f1f1',
              textAlign: 'center',
              padding: '10px'
            }}
            gutterBottom
          >
            Room Price Form
          </Typography>

          {/* Conference Selection */}
          <div className="input-group" style={{ marginBottom: '20px' }}>
            <Select
              options={allConference}
              value={conferenceId}
              setValue={setConferenceId}
              label="Conference"
              placeholder="Select Conference"
              required={true}
            />
          </div>

          {/* Hotels Section */}
          <div className="hotels-section">
            {hotels.map((hotel, index) => (
              <div key={index} className="hotel-card" style={{
                border: '2px solid #e0e0e0',
                borderRadius: '8px',
                padding: '20px',
                marginBottom: '15px',
                backgroundColor: '#fafafa'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <Typography variant="h6" sx={{ color: '#c62828' }}>
                    Hotel {index + 1}
                  </Typography>
                  {hotels.length > 1 && (
                    <IconButton onClick={() => removeHotel(index)} color="error">
                      <DeleteIcon />
                    </IconButton>
                  )}
                </div>

                <div className="input-group" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                  <Input
                    label={`Hotel Name`}
                    placeholder="Enter Hotel Name"
                    inputValue={hotel.hotelName}
                    setInputValue={(value) => updateHotelField(index, 'hotelName', value)}
                    required={true}
                    style={{ flex: '1', minWidth: '200px' }}
                  />
                  
                  {/* ✅ FIXED STAR RATING SELECT */}
                  <Select
                    options={starRatingOptions}
                    value={getStarRatingValue(hotel.starRating)}  // Ye line fix hai
                    setValue={(value) => updateHotelField(index, 'starRating', value?.value || '')}
                    label="Star Rating"
                    placeholder="Select Stars"
                    required={true}
                    style={{ flex: '1', minWidth: '200px' }}
                  />
                </div>

                <div className="input-group" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '15px' }}>
                  <Input
                    label="Single Base Price (USD)"
                    placeholder="Enter price"
                    inputValue={hotel.singleBasePrice}
                    setInputValue={(value) => updateHotelField(index, 'singleBasePrice', value)}
                    required={true}
                    type="number"
                  />
                  
                  <Input
                    label="Double Base Price (USD)"
                    placeholder="Enter price"
                    inputValue={hotel.doubleBasePrice}
                    setInputValue={(value) => updateHotelField(index, 'doubleBasePrice', value)}
                    required={true}
                    type="number"
                  />
                  
                  <Input
                    label="Triple Base Price (USD)"
                    placeholder="Enter price"
                    inputValue={hotel.tripleBasePrice}
                    setInputValue={(value) => updateHotelField(index, 'tripleBasePrice', value)}
                    required={true}
                    type="number"
                  />
                </div>
              </div>
            ))}

            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={addHotel}
                sx={{ color: '#c62828', borderColor: '#c62828' }}
              >
                Add More Hotel
              </Button>
            </div>
          </div>

          <div className="submit-btn-container">
            <button
              className={`submit-btn ${(!conferenceId?.value || hotels.some(h => !h.hotelName || !h.starRating || !h.singleBasePrice || !h.doubleBasePrice || !h.tripleBasePrice)) ? "disabled" : ""}`}
              type="submit"
              disabled={!conferenceId?.value || hotels.some(h => !h.hotelName || !h.starRating || !h.singleBasePrice || !h.doubleBasePrice || !h.tripleBasePrice)}
            >
              Add Room Prices
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RoomPriceForm;